'use strict';

import { view } from '@/functions';

const prefix = '/pos-information';

export default [
    {
        path: prefix,
        name: 'pos-information',
        meta: {
            title: 'POS information',
            scopes: ['read_pos_information', 'write_pos_information']
        },
        component: () => view('pos-information/index'),
    },
    {
        path: `${prefix}/info`,
        name: 'pos-information-info',
        meta: {
            title: 'POS information',
            scopes: ['read_pos_information', 'write_pos_information']
        },
        component: () => view('pos-information/info'),
    },
];

